import api from '../axios/axiosInstance';

export type SubscriptionStatus = {
  _id: string;
  userId: string;
  status: 'trial' | 'active' | 'expired' | 'inactive';
  billingCycle: string;
  startDate: string;
  endDate: string;
  trialDays: number;
  amount: number;
  currency: string;
  autoRenew: boolean;
  createdAt: string;
  updatedAt: string;
};

export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
  const response = await api.get('/users/subscription-status');
  return response.data;
};
